import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AuthService } from "../auth.service";

type Role = "isAdmin" | "isProducer" | "isHost" | "isMarketer";

export const roleGuard =
    (...roles: Role[]): CanActivateFn =>
    () => {
        const auth = inject(AuthService);
        const router = inject(Router);
        const hasRole = roles.some(role => auth[role]());
        return hasRole ? true : router.createUrlTree(["/"]);
    };
